import React from 'react';
import { useDarkMode } from './DarkModeContext';
import HolidayApprovalsSection from './HolidayApprovalsSection';
import LeaveCancellationsSection from './LeaveCancellationsSection';
import LeaveDecisionHistorySection from './LeaveDecisionHistorySection';
import LeaveCancellationHistorySection from './LeaveCancellationHistorySection';
import FPValidationSection from './FPValidationSection';

// "Validation" - a role-agnostic capability shown to any account that is someone's line manager,
// or that is the resolved COO fallback-approver for an employee with no manager_id (derived from
// GET /employees/me's is_manager/is_approver fields, not a stored role - see each shell's own
// nav-item gating). Deliberately structured as a sectioned page - one component per approval
// type - so future approval types beyond Holiday can be added as additional sections later
// without restructuring this page. Only Holiday exists today.
export default function ValidationView() {
  const { isDarkMode } = useDarkMode();
  const textCol = isDarkMode ? '#e8e4d8' : '#1a1a2e';
  const GOLD = '#c9a84c';

  return (
    <div style={{ maxWidth: '760px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: textCol, margin: '0 0 6px' }}>Validation</h2>
      <div style={{ height: '3px', width: '48px', background: GOLD, borderRadius: '2px', margin: '0 0 20px' }} />

      <HolidayApprovalsSection />
      {/* LEAVECANCEL: the second section, exactly as this page was built to accommodate. Placed
          BELOW the approvals rather than above deliberately - a new leave request is time
          sensitive (the leave has not happened yet and the person is waiting to book around the
          answer), while a cancellation concerns a leave that is already agreed and whose default
          outcome, if nothing is done, is simply that it stands. Approvals therefore keep the top
          of the page. */}
      <LeaveCancellationsSection />
      {/* DECISIONHIST: a read-only history of decided HOLIDAY REQUESTS (not cancellations),
          placed after both action sections for the same reason CANCELHIST's history is - work
          still owed must never compete for attention with a record of work already done. Placed
          BEFORE the cancellation history so the two histories mirror the order of the two action
          sections above them (approvals, then cancellations) - a deliberate, separate section
          rather than merged with the cancellation history, since "may this leave happen" and "may
          this already-granted leave be undone" are different questions with different audit
          actions behind them. */}
      <LeaveDecisionHistorySection />
      {/* CANCELHIST: the cancellation history sits LAST, below every other section. The ones
          above are work the manager still owes, or another (distinct) read-only record; this is a
          read-only record of work already done, so it must never compete for attention with a
          decision that is still outstanding. */}
      <LeaveCancellationHistorySection />
      {/* FPFRONTEND: the F&P review chain (stages 2-5) - exactly the "future approval type added
          as an additional section" this page was built to accommodate. It renders only the
          assessments genuinely awaiting THIS viewer, so a manager, HR and compliance each see
          their own stage here and nothing else. Placed last, after the leave sections, since the
          existing ones are the page's established content. */}
      <FPValidationSection />
      {/* Future approval types are added here as additional sections. */}
    </div>
  );
}
